'use client';

import { m, Variants } from 'framer-motion';
import { Globe2, WalletCards, MapPin, ShieldCheck, Clock, Users } from 'lucide-react';
import styles from './Advantages.module.css';

const advantages = [
    {
        icon: Globe2,
        title: 'Integrasi Teknologi',
        description: 'Monitoring pengiriman secara real-time dan dokumentasi digital (foto muat & bongkar) untuk transparansi penuh.',
    },
    {
        icon: ShieldCheck,
        title: 'Expertise',
        description: 'Dikelola oleh tenaga ahli yang telah menangani ribuan pengiriman domestik & internasional.',
    },
    {
        icon: WalletCards,
        title: 'Customized Solution',
        description: 'Layanan yang fleksibel sesuai budget dan kebutuhan bisnis klien. B2B Specialist.',
    },
    {
        icon: Users,
        title: 'Professionalism & Amanah',
        description: 'Bekerja sesuai standar tertinggi dan jujur dalam setiap transaksi serta laporan keuangan (Prinsip Muamalah).',
    },
    {
        icon: Clock,
        title: 'Fast Response & Innovative',
        description: 'Kecepatan membalas klien adalah kunci, didukung inovasi teknologi untuk solusi yang lebih cepat dan efisien.',
    },
    {
        icon: MapPin,
        title: 'Integrity & Customer Centric',
        description: 'Konsisten antara janji dan eksekusi di lapangan. Kepuasan pelanggan adalah prioritas utama kami.',
    },
];

const containerVariants: Variants = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.15,
        },
    },
};

const cardVariants: Variants = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

export default function Advantages() {
    return (
        <section id="keunggulan" className={`section ${styles.advantages}`}>
            {/* Background glowing orbs */}
            <div className={styles.glowOrb1} />
            <div className={styles.glowOrb2} />

            <div className={`container ${styles.container}`}>
                <m.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.6 }}
                    className={`section-header ${styles.sectionHeaderDark}`}
                >
                    <span className={`section-label ${styles.sectionLabel}`}>Keunggulan Kami</span>
                    <h2 className={`section-title ${styles.sectionTitle}`}>Mengapa Memilih Kami?</h2>
                    <p className={`section-subtitle ${styles.sectionSubtitle}`}>
                        Kepercayaan ribuan pelanggan menjadi bukti komitmen kami dalam memberikan
                        layanan logistik terbaik di Indonesia.
                    </p>
                </m.div>

                <m.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-50px" }}
                    className={styles.grid}
                >
                    {advantages.map((item) => (
                        <m.div
                            key={item.title}
                            variants={cardVariants}
                            whileHover={{ y: -10 }}
                            className={styles.card}
                        >
                            <div className={styles.iconWrap}>
                                <item.icon className={styles.icon} size={32} strokeWidth={1.5} />
                            </div>
                            <h3 className={styles.cardTitle}>{item.title}</h3>
                            <p className={styles.cardDescription}>{item.description}</p>

                            {/* Decorative border line */}
                            <div className={styles.cardBorder} />
                        </m.div>
                    ))}
                </m.div>
            </div>
        </section>
    );
}
